import { Stack } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { getProducts } from '../../../actions'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { resetService } from '../../../slices/orderSlice'
import { customStyles } from '../../../styles'
import { MainContainer } from '../../containers'
import { MainButton, RegularText } from '../../helpers'
import { ModalHeader } from '../../modals'
import { ByCostOrLiters } from './ByCostOrLiters'
import { InfoEstacionario } from './InfoEstacionario'
import { QtEstacionario } from './QtEstacionario'

export const EstacionarioView = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { id } = useParams()
  const { service, account, subTotal } = useSelector(state => state.order)
  const { data } = useSelector(state => state.products)
  const { isByCost } = useSelector(state => state.order)
  const [authorization] = useLocalStorage('login-token', null)
  const [error, setError] = useState(false)
  const handleCancel = () => {
    dispatch(resetService())
    navigate('/dashboard/content', { replace: true })
  }

  const handleAdd = () => {
     navigate('/dashboard/preview')
  }

  useEffect(() => {
    !account && navigate('/dashboard/content')
  }, [])
  
  return (
    <MainContainer >
      <ModalHeader text="Solicitar Gas Estacionario"/>
      <ByCostOrLiters />
      {/* <QTCilinders />
      <InfoCilinder /> */}
      <QtEstacionario subTotal={subTotal}/>
     
      <InfoEstacionario  error={error} setError={setError}/>
      <Stack mt={5} direction="row" spacing={3}>
        <MainButton text="CANCELAR" variant="outlined" size="50%" onClick={ handleCancel }/>
        <MainButton text="AGREGAR" variant="contained" size="50%" onClick={handleAdd} disabled={error}/>
      </Stack>
    </MainContainer>
  )
}
